import { render } from "./custom-forms.vue?vue&type=template&id=194258a2&lang=html"
import script from "./custom-forms.vue?vue&type=script&lang=js"
export * from "./custom-forms.vue?vue&type=script&lang=js"

import "./custom-forms.vue?vue&type=style&index=0&id=194258a2&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__